import React, { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { Button } from '../../components/Button'
import { useLocation, useNavigate } from 'react-router-dom'
import api from 'services/api'
import { translate } from '../../i18n'
import { useTranslation } from 'react-i18next'
import { Stack, TextField, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { showMessage } from 'redux/reducers/snackbar/snackbar.actions'
import { useAppDispatch } from 'redux/hooks'

const signInSchema = yup.object({
  code: yup
    .string()
    .trim()
    .required(() => translate('verification.required.code'))
    .min(6, () => translate('verification.required.codeSize'))
})

export interface VerificationFormProps {
  code: string
  userId: string
}

export const Verification = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(false)

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<VerificationFormProps>({
    resolver: yupResolver(signInSchema)
  })

  const handleValidate = async (dataPost: VerificationFormProps) => {
    dataPost.userId = location.state.userId
    setLoading(true)

    try {
      const result = await api.post(`/users/${dataPost.userId}/verify`,
        { code: dataPost.code },
        { headers: { 'Content-Type': 'application/json' } })
      if (result) {
        dispatch(showMessage({ message: `${t('account.created_success')}` }))
        navigate('/signIn')
      }
    } catch (e) {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title> Verification | DWF </title>
      </Helmet>
      <Stack sx={{ mb: '10px' }}>
        <Typography variant="h4">
          {t('verification.message')}
        </Typography>
      </Stack>
      <Stack sx={{ mb: '20px' }}>
        <Typography variant="subtitle2">
          { location.state.email }
        </Typography>
      </Stack>
      <Stack sx={{ mb: '20px' }}>
        <Controller
          control={control}
          name="code"
          render={({ field: { onChange } }) => (
            <TextField
              placeholder={t<string>('verification.field.code.placeholder')}
              label={t<string>('verification.field.code.label')}
              onChange={onChange}
              autoCapitalize="none"
              helperText={errors.code?.message}
              error={errors.code?.message !== undefined}
            />
          )} />
      </Stack>
      <Stack>
        <Button
          title={t('verification.btn.verify')}
          isLoading={loading}
          onClick={handleSubmit(handleValidate)}
        />
      </Stack>
    </>
  )
}
